import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { articles } from "@/mocks/articles";

function accentClasses(accent: string) {
  if (accent === "accent") {
    return "bg-accent-100 text-accent-900 group-hover:bg-accent-200";
  }
  if (accent === "secondary") {
    return "bg-secondary-100 text-secondary-900 group-hover:bg-secondary-200";
  }
  return "bg-primary-100 text-primary-700 group-hover:bg-primary-200";
}

export default function CategoryShowcase() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-14">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-2xl tracking-wide text-foreground-950 md:text-3xl">主题分类</h2>
          <p className="mt-2 text-sm text-foreground-600">按你感兴趣的方向，快速找到今天的瓜。</p>
        </div>
        <Link
          to="/search"
          className="flex items-center gap-1 whitespace-nowrap text-sm text-primary-600 transition-colors hover:text-primary-700"
        >
          全部分类
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {categories.map((cat) => {
          const count = articles.filter((item) => item.categorySlug === cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
            >
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-lg transition-colors ${accentClasses(cat.accent)}`}
              >
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-xl tracking-wide text-foreground-950">{cat.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.description}</p>
              <span className="mt-4 flex items-center gap-1 text-xs text-foreground-500">
                {count} 篇爆料
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}